import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IMedicationsModel } from './types';

const medications: IMedicationsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default medications;
